export default function Select({
  field,
  form,
  label,
  icon,
  options = [],
  placeholder,
  onChange,
  disabled = false,
}) {
  const hasError = form.touched?.[field.name] && form.errors?.[field.name];

  const handleChange = (e) => {
    if (onChange) onChange(e);
    else field.onChange(e);
  };

  const placeholderText = placeholder || `Select ${label}`;

  return (
    <div className="mb-6">
      {label && (
        <label
          htmlFor={field.name}
          className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-300"
        >
          {label}
        </label>
      )}

      <div
        className={`group relative overflow-hidden rounded-2xl border bg-white transition-all dark:bg-slate-900 ${
          hasError
            ? "border-red-400 ring-2 ring-red-100 dark:border-red-500/70 dark:ring-red-500/10"
            : "border-slate-300 hover:border-slate-400 dark:border-slate-700 dark:hover:border-slate-500"
        } ${
          disabled
            ? "cursor-not-allowed bg-slate-100 opacity-70 dark:bg-slate-800/70"
            : "focus-within:border-slate-900 focus-within:ring-4 focus-within:ring-slate-200 dark:focus-within:border-white dark:focus-within:ring-slate-800"
        }`}
      >
        {icon && (
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-slate-400 dark:text-slate-500">
            {icon}
          </span>
        )}

        <select
          id={field.name}
          name={field.name}
          value={field.value ?? ""}
          onChange={handleChange}
          disabled={disabled}
          className={`w-full appearance-none bg-transparent px-4 py-3 text-sm font-medium outline-none transition ${
            icon ? "pl-10" : ""
          } ${
            field.value
              ? "text-slate-900 dark:text-white"
              : "text-slate-400 dark:text-slate-500"
          } ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
        >
          <option value="" disabled>
            {placeholderText}
          </option>

          {options.map((opt, i) => {
            const value = typeof opt === "object" ? opt.value : opt;
            const text = typeof opt === "object" ? opt.label : opt;

            return (
              <option key={i} value={value}>
                {text}
              </option>
            );
          })}
        </select>

        <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-xs text-slate-400 dark:text-slate-500">
          ▼
        </span>
      </div>

      {hasError && (
        <p className="mt-2 text-xs font-medium text-red-600 dark:text-red-400">
          {form.errors[field.name]}
        </p>
      )}
    </div>
  );
}